import { engineModule } from './engineModule';

declare global {
    var start_engine_thread: (name: string) => Worker;
}

globalThis.start_engine_thread = (name: string) => {
    const url = new URL('thread.js', document.baseURI);
    url.searchParams.set('task', name);
    const worker = new Worker(url, { name, type: 'module' });
    worker.postMessage(engineModule());
    return worker;
};
